<template >
    <!-- 검색뷰 일때 -->
    <router-link v-if="searchview" :to="getPath()">
        <span @click="updateCount(list.id)" :class="{isview:isView}">
            <span :class="mode">{{ getTitle(list.title)}}</span>
            <span v-if="list.comment>0" class="comment_count">[{{list.comment}}]</span>
        </span>
    </router-link>
    
    
    <router-link v-else :to="getPath()">
        <span @click="updateCount(list.id)" :class="{isview:isView}">
            <span :class="mode">{{ getTitle(list.title)}}</span>
            <span v-if="list.comment>0" class="comment_count">[{{list.comment}}]</span>
        </span>
    </router-link>
</template>


<script>
import { postLink } from '@/utils/menu';
export default {   
    props: {
        document: {
            type: String,
            required: true,
            default: null
        },
        list: {
            //type: Array,
            required: true,
            default: null
        },
        menu: {
            //type: Array,
            required: true,
            default: null
        },
        lengthLimit: {
            type: Number,
            required: false,
            default: 30
        },
        mode: {
            type: String,
            required: false,
            default: null
        },
        searchview: {
            //type: Array,
            required: false,
            default: false
        },
        isMobile:{
            required: false,
            default: false,       
        }
    },
    computed:{
        isView(){
            return this.$store.state.menu.viewPost.some(viewPost=>viewPost === this.list.id);
        },
        currentMenu(){
            if(this.menu)
            {          
                return this.$store.getters['menu/getMenu'].find((menu)=>menu.title === this.list.document.menu).name    
            }else{
                return this.$store.state.menu.activeMenu;
            }            
        },
       
    },
    methods: {
        getPath()
        {
            if(this.searchview)
            {
                if(this.isMobile === 'isMobile')
                {
                    return `/m/community/postsearch/view/${this.list.id}`
                }else{
                    return `/main/community/postsearch/view/${this.list.id}`
                }   
               
            }else{
                if(this.isMobile === 'isMobile')
                {
                    return `/m/community/${this.currentMenu}/${this.document}/view/${this.list.id}`
                }else{
                    return `/main/community/${this.currentMenu}/${this.document}/view/${this.list.id}`
                }
            }
           
        },
        getTitle(title)
        {               
            return title.substr(0, this.lengthLimit) + (title.length >this.lengthLimit?'...':'') ;
        },
        updateCount(list_id){
            
            const menu = this.$store.getters['menu/getMenu'].find((menu)=>menu.title === this.list.document.menu).name;
           
           
            //return false;
            postLink(list_id,menu,this.document,this.$store);   
            // if(!this.isView)
            // {
            //     //안본것만 조회수 업데이트
            //     this.$store.dispatch("posts/updateCount", list_id);
            // }
            // this.$store.dispatch("menu/setViewPost", list_id)
            // this.$store.dispatch("posts/getRecommend", {user_id:1, post_id:list_id})
            // // if(this.menu)
            // // { 
            //     this.$store.commit("menu/setActiveMenu", this.$store.getters['menu/getMenu'].find((menu)=>menu.title === this.list.document.menu).name    );
            // // }
            // // this.$store.commit("menu/setActiveSubMenu", this.document);
            
        }
    },
    //$store.getters.isAuthenticated
}
</script>
<style lang="scss" scoped>
.isview{
    color:#7e807e
}
.comment_count{
    color:red;
}
.main{
    color:#fff;
}

</style>
